// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Yi8pw","content":"Footer_content__vDSSk","text":"Footer_text__F5hGW","dot":"Footer_dot__H-0d5","link":"Footer_link__d8jxW"};